module.exports = __webpack_public_path__ + "img/magento-code-review.022d4079.jpeg";